import styled from '@emotion/styled';
export const SearchBoxContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
`;

export const SearchBoxControlsContainer = styled.div`
  display: flex;
  width: 50%
  min-width:150px;
  align-items: center;
  justify-content: flex-end;
`;
export const SearchBoxFieldContainer = styled.div`
  display: flex;
  width: 50%
  min-width:100px;
  margin-right: 5px;
  align-items: center;
`;
